import { Icon16Adjust, Icon16Histogram, Icon24AdjustLarge, Icon24HistogramLarge } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const SlidersIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M15 18.75C15 17.5074 13.9926 16.5 12.75 16.5C11.5074 16.5 10.5 17.5074 10.5 18.75C10.5 19.9926 11.5074 21 12.75 21C13.9926 21 15 19.9926 15 18.75Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 12C10.5 10.7574 9.49264 9.75 8.25 9.75C7.00736 9.75 6 10.7574 6 12C6 13.2426 7.00736 14.25 8.25 14.25C9.49264 14.25 10.5 13.2426 10.5 12Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 5.25C18 4.00736 16.9926 3 15.75 3C14.5074 3 13.5 4.00736 13.5 5.25C13.5 6.49264 14.5074 7.5 15.75 7.5C16.9926 7.5 18 6.49264 18 5.25Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 18.75L10.5 18.75"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 5.25L13.5 5.25"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3.75 12L6 12" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M15 18.75L20.25 18.75"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 5.25L20.25 5.25"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 12L20.25 12"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SlidersIcon = fplIcon(SlidersIconLocal, Icon24AdjustLarge);

/** The same glyph at 16px, for rows sized to a 16px icon. FPL draws `SlidersIcon` at 24. */
export const SlidersIcon16 = fplIcon(SlidersIconLocal, Icon16Adjust);

/**
 * Levels on the node header and in the models menu.
 * Flag-on draws `icon.24.histogram.large`, the same 24-large box `SlidersIcon` uses there.
 */
export const LevelsIcon = fplIcon(SlidersIconLocal, Icon24HistogramLarge);

/**
 * Levels on compositor effect rows.
 * Flag-on draws `icon.16.histogram`, the same 16px box `SlidersIcon16` uses there.
 */
export const LevelsIcon16 = fplIcon(SlidersIconLocal, Icon16Histogram);
